export default __webpack_public_path__ + "static/media/back.737bb925.png";